import React from 'react';

import Alert from 'ui/Alert';

import { useCurrentUser } from '../../utils/user';

// TODO: Rename component to ...Alert
const AdminNotOfficialEditorBanner: React.FC = () => {
  const { user } = useCurrentUser();

  if (user && user.is_superuser && !user.is_official_sankey_editor) {
    return (
      <Alert
        status="warning"
        title="You are a superuser but not an official Sankey editor"
      >
        This state is not supported. Please assign yourself official Sankey
        editor rights using the Django admin UI.
      </Alert>
    );
  }

  return null;
};

export default AdminNotOfficialEditorBanner;
